<template>
    <div>
		<b-card no-body class="mb-3 p-20">
			<h1>Customer Quotation</h1>
		</b-card>
        

        <panel class="border border-secondary mt-4" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter</h4>
            </template>

            <div class="row">
                <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                    <label for="partshopCode">Cari</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ketik teks"
                        style="height: 43px;"
                        v-model="filter.search"
                        v-on:keyup.enter="vue_universal_table.update++"
                    />
                </div>
                <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
                    <label for="partshopCode">Periode</label>
                    <div class="block w-100 datepickerSeperator">
                        <DatePicker
                            class="w-100"
                            v-model="selected.date"
                            type="monthrange"
                            align="right"
                            format="MMM yyyy"
                            range-separator="-"
                            start-placeholder="Start"
                            end-placeholder="End"
                            :picker-options="pickerOptions"
                            style="height:43px"
                        >
                        </DatePicker>
                    </div>
                </div>
                <div
                    class="col-md-3 offset-md-3"
                    style="display: flex; flex-direction: column-reverse"
                    :class="mobile ? 'pt-20' : ''"
                >
                    <button
                        type="button"
                        class="btn btn-primary"
                        style="height:38px; margin-bottom:0.5%"
                        @click="vue_universal_table.update++"
                    >
                        Filter
                    </button>
                </div>
            </div>
        </panel>

		<div class="mt-3 mb-3 row">
			<div class="col-lg-3 offset-lg-9 col-12">
				<button
					class="w-100 btn btn-success"
					@click="$router.push({ name: 'CSOCustomerQuotationCreateV2' })"
				>
					Quotation Baru
				</button>
			</div>
		</div>

		<b-card no-body class="p-20">
			<vue-universal-table
				:api_url="'/api/v1/quotation'"
				:buttons="vue_universal_table.buttons"
				:fields="vue_universal_table.fields"
				:update="vue_universal_table.update"
				:filter="filter"
				:sort_by="'created_at'"
				:sort_order="'DESC'"
				@onBuatBaru="$router.push({ name: 'CSOCustomerQuotationCreateV2' })"
				:row_style_condition="{
					'work_order_created == true': 'background-color : #f8ff6b'
				}"
				@onView="viewDetail"
				@onPrint="printDetail"
				@onEdit="editQuotation"
			></vue-universal-table>
		</b-card>

        

        <customer-quotation-detail
            v-if="modal.view"
            :detailId="detailId"
            @closeModal="modal.view = false"
        ></customer-quotation-detail>

        <print-customer-quotation
            v-if="modal.print"
            :detailId="detailId"
            @closeModal="modal.print = false"
        ></print-customer-quotation>
    </div>
</template>

<script>
import customerQuotationDetail from './children/customerQuotationDetail';
import printCustomerQuotation from './children/printCustomerQuotation';
import { DatePicker } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import moment from 'moment';

locale.use(lang);

export default {
    data() {
        const start = moment()
            .subtract(4, 'months')
            .startOf('month')
            .format('YYYY-MM-DD');
        let end = new moment().endOf('month').format('YYYY-MM-DD');
        return {
            mobile: this.isMobile(),
            modal: {
                view: false,
                print: false
            },
            // rangeConfig: {
            //   mode: 'range',
            //   altInput: true,
            //   altInputClass: 'form-control input flatpickr-input w-100',
            //   animate: !this.isRTL()
            // },
            pickerOptions: {
                shortcuts: [
                    {
                        text: 'Bulan Ini',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    },
                    {
                        text: 'Tahun Ini',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '6 Bulan Terakhir',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            detailId: '',
            selected: {
                date: [
                    new Date().setMonth(new Date().getMonth() - 4),
                    new Date()
                ]
            },
            filter: {
                search: '',
                hideDone: true,
				start : start,
				end : end
            },
            vue_universal_table: {
                special_buttons: ['buatBaru'],
                buttons: [
                    {
                        title: 'View',
                        class: 'btn btn-outline-danger fas fa-eye'
                    },
                    {
                        title: 'Edit',
                        class: 'btn btn-outline-primary fas fa-edit'
                    },
                    {
                        title: 'Print',
                        class: 'btn btn-outline-success fas fa-print'
                    }
                ],
                fields: [
                    {
                        title: 'Reference Code',
                        variable: 'form_code'
                    },
                    {
                        title: 'Customer Name',
                        variable: 'name'
                    },
                    {
                        title: 'Nomor Polisi Mobil',
                        variable: 'registration'
                    },
                    {
                        title: 'Dibuat Pada',
                        variable: 'created_at'
                    }
                ],
                update: 0
            }
        };
    },
    components: {
        customerQuotationDetail,
        printCustomerQuotation,
        DatePicker
    },
    mounted() {},
    watch: {
        'selected.date'() {
            // console.log
            this.filter.start = new moment(this.selected.date[0])
                .startOf('month')
                .format('Y-MM-DD');
            this.filter.end = new moment(this.selected.date[1])
                .endOf('month')
                .format('Y-MM-DD');
        }
    },
    methods: {
        viewDetail(a) {
            this.detailId = JSON.parse(a).form_code;
            this.modal.view = true;
        },
        printDetail(a) {
            this.detailId = JSON.parse(a).form_code;
            this.modal.print = true;
        },
        editQuotation(a) {
            let form_code = JSON.parse(a).form_code;
            this.$router.push({
                name: 'CSOCustomerQuotationEdit',
                params: { form_code: form_code }
            });
        }
    }
};
</script>

<style scoped></style>
